"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var tf = _interopRequireWildcard(require("@tensorflow/tfjs"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var classes = exports.classes = ['ai_learning_speech'];
var _type = /*#__PURE__*/new WeakMap();
var _url = /*#__PURE__*/new WeakMap();
var _labels = /*#__PURE__*/new WeakMap();
var _recordTime = /*#__PURE__*/new WeakMap();
var _result = /*#__PURE__*/new WeakMap();
var Classification = /*#__PURE__*/function () {
  function Classification(_ref) {
    var url = _ref.url,
      labels = _ref.labels,
      type = _ref.type,
      recordTime = _ref.recordTime;
    (0, _classCallCheck2["default"])(this, Classification);
    _classPrivateFieldInitSpec(this, _type, null);
    _classPrivateFieldInitSpec(this, _url, '');
    _classPrivateFieldInitSpec(this, _labels, []);
    _classPrivateFieldInitSpec(this, _recordTime, 2000);
    _classPrivateFieldInitSpec(this, _result, []);
    _classPrivateFieldSet(_type, this, type);
    _classPrivateFieldSet(_url, this, url);
    _classPrivateFieldSet(_labels, this, labels);
    _classPrivateFieldSet(_recordTime, this, recordTime);
    this.load(url);
  }
  return (0, _createClass2["default"])(Classification, [{
    key: "labels",
    get: function get() {
      return _classPrivateFieldGet(_labels, this);
    }
  }, {
    key: "getResult",
    value: function getResult(index) {
      var _this = this;
      var result = _classPrivateFieldGet(_result, this) || [];
      var defaultResult = {
        probability: 0,
        className: ''
      };
      if (index !== undefined && index > -1) {
        return result.find(function (_ref2) {
          var className = _ref2.className;
          return className === _classPrivateFieldGet(_labels, _this)[index];
        }) || defaultResult;
      }
      return result[0] || defaultResult;
    }
  }, {
    key: "unbanBlocks",
    value: function unbanBlocks(blockMenu) {
      blockMenu.unbanClass("ai_learning_classification");
      if (_classPrivateFieldGet(_type, this)) {
        blockMenu.unbanClass("ai_learning_".concat(_classPrivateFieldGet(_type, this)));
      }
    }
  }, {
    key: "openInputPopup",
    value: function openInputPopup() {
      var _this2 = this;
      Entry.dispatchEvent('openMLInputPopup', {
        type: _classPrivateFieldGet(_type, this),
        recordTime: _classPrivateFieldGet(_recordTime, this),
        predict: function () {
          var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
            var _t, _t2, _t3;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _t = _classPrivateFieldSet;
                  _t2 = _result;
                  _t3 = _this2;
                  _context.next = 1;
                  return _this2.predict(data);
                case 1:
                  _t(_t2, _t3, _context.sent);
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function predict(_x) {
            return _predict.apply(this, arguments);
          }
          return predict;
        }(),
        url: _classPrivateFieldGet(_url, this),
        labels: _classPrivateFieldGet(_labels, this),
        setResult: function setResult(result) {
          _classPrivateFieldSet(_result, _this2, result);
        }
      });
    }
  }, {
    key: "namePredictions",
    value: function () {
      var _namePredictions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(logits) {
        var _this3 = this;
        var values, _t4;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _t4 = Array;
              _context2.next = 1;
              return logits.data();
            case 1:
              values = _t4.from.call(_t4, _context2.sent);
              return _context2.abrupt("return", values.map(function (probability, index) {
                return {
                  className: _classPrivateFieldGet(_labels, _this3)[index] || index,
                  probability: probability
                };
              }).sort(function (a, b) {
                return a.probability > b.probability ? -1 : a.probability < b.probability ? 1 : 0;
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function namePredictions(_x2) {
        return _namePredictions.apply(this, arguments);
      }
      return namePredictions;
    }()
  }, {
    key: "predict",
    value: function () {
      var _predict2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(tensor) {
        var logits;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              logits = this.model.predict(tensor);
              _context3.next = 1;
              return this.namePredictions(logits);
            case 1:
              return _context3.abrupt("return", _context3.sent);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function predict(_x3) {
        return _predict2.apply(this, arguments);
      }
      return predict;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(url) {
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return tf.loadLayersModel(url);
            case 1:
              this.model = _context4.sent;
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function load(_x4) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "reload",
    value: function () {
      var _reload = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(url) {
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return tf.loadLayersModel(url || _classPrivateFieldGet(_url, this));
            case 1:
              this.model = _context5.sent;
              this.isLoaded = true;
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function reload(_x5) {
        return _reload.apply(this, arguments);
      }
      return reload;
    }()
  }]);
}();
var _default = exports["default"] = Classification;